module.exports = __webpack_public_path__ + "img/lancamento_banner_mobile_procura.3f2a83ff.webp";